/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-10 11:23:12
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-10 12:27:25
 */

export interface IResize {
  overlay: HTMLElement;
  img: HTMLImageElement;
  onUpdate: () => void;
}

export class BaseModule {
  public overlay: HTMLElement;
  public img: HTMLImageElement;
  public requestUpdate: () => void;

  constructor(resizer: IResize) {
    this.overlay = resizer.overlay;
    this.img = resizer.img;
    this.requestUpdate = resizer.onUpdate;
  }

  onCreate = () => {
    // create
  };

  onDestroy = () => {
    // onDestroy
  };

  onUpdate = () => {
    // onUpdate
  };
}
